import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../../shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent } from '../../../shared/base/base.component';
import { MatomoTracker } from 'ngx-matomo';
import { ActivatedRoute, Router } from '@angular/router'
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { delay, filter } from 'rxjs/operators';
import { differenceInCalendarDays, addDays, parseISO, format, differenceInDays } from 'date-fns';
import { DatePipe } from '@angular/common'
import { TranslateService } from '@ngx-translate/core';
import { v4 as uuidv4 } from 'uuid';
import { Console } from 'console';

interface WHQMaintainDto {
  Pono: string;
  Currency: string;
  InvoiceDate: string;
  InvoiceAmount: string;
  InvoiceNo: string;
  Taxes: string;
  remake: string;
}
interface ItemData {
  id: number;
  invoiceType: string
}
interface ItemCheckData {
  id: number;
  bind_id: number
}

interface departDatadata {
  id: string
  maintainTime: Date
  dis: string
  mDeptno: string
  cDeptno: string
  edit: boolean
  po: string
}

interface editDeptsadata {
  chargeDeptNo: string
  dis: number
  itemNo: string
  originalChargeDeptNo: string
  projectCode: string
  edit: boolean,
  prchargeid: string
}
@Component({
  selector: 'app-edit-wmsm-ElectronicInvoice',
  templateUrl: './edit-wmsm-ElectronicInvoice.component.html',
  styleUrls: ['./edit-wmsm-ElectronicInvoice.component.css'],
  providers: []
})
export class EditWmsmElectronicInvoice extends BaseComponent implements OnInit {
  nontaxInvoiceAmountControl = new FormControl('', Validators.pattern(/^\d{1,3}(,\d{3})*(\.\d+)?$/));
  fileList: NzUploadFile[] = [];
  loading: boolean = false;
  isLoadingPaymentInfo: boolean = false;
  isShowCondition: boolean = true;
  // 表格每页显示条数,默认每頁顯示10筆資料
  pageSize: number = 20;
  // 表格页码
  pageIndex: number = 1;
  nzTotal: number = 0;
  validateForm: FormGroup;
  RTDetailForm: FormGroup;
  showFiles: boolean;
  fixedColumn = true;
  i = 0;
  editId: Number | null = 0;
  dateFormat = 'yyyy/MM/dd';
  FirstInvoiceDate;
  RNO: any;
  Pono: string;
  Currency: any;
  Company: any;
  disabledPONO: boolean = false;
  InvoiceSerialNumberIsNull: boolean = true;
  InvoiceInfo: any[] = [];
  ReceiptInfo: any[] = [];
  SubmitInvoiceInfo: any[] = [];
  SubmitReceiptInfo: any[] = []
  GetMaintainData: any;
  invoiceNo: any;
  Filename: any;
  otd1_Visible: boolean;
  otd2_Visible: boolean;
  Vendor_Punctual_Visible: boolean;
  Delay_Visible: boolean
  inputvalue: string;
  IsInputValue: boolean = false;
  tw: boolean;
  cn: boolean;
  en: boolean;
  InvoiceDatevalue: boolean = false;
  NontaxInvoiceAmountvalue: boolean = false;
  Taxesvalue: boolean = false;
  today = new Date();
  expectDueDateDefault = addDays(new Date(), 5);  // 默认显示可选的第一天
  nzShowButton: boolean = true;
  Uploadfilelink: any;
  InvoiceNodata: any;
  uploadfilename: any;
  Submitdata: any[] = [];
  Role: string = '';
  ChangeValue: any;
  ExcelControl = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  InvoiceInfoSerialNumberList: any[] = [];
  SerialNumberInInvoice: boolean = true;
  count = 0;
  InvoiceCodeIsNull: boolean = true;
  InvoiceNoIsNull: boolean = true;
  rowID: any;
  booleaninvoiceno: boolean;
  uploadValue: boolean;
  disabledfile: boolean;
  tabdisabled: boolean = false;
  checkboolean: boolean;
  tabIndex: number = 0;
  OptionList: []
  selectedValue: "";
  nzPlaceHolder: string;
  RejectinputValue: string;
  suggestion = [];
  fileindex: number
  formattingdate: any;
  DetailInvoiceNoList = []
  InvoiceNoList: any[] = [];
  setOfCheckedId = new Set<number>();
  FirstsetOfCheckedId = new Set<number>();
  checked: boolean = false;
  indeterminate = false;
  listOfCurrentPageData: readonly ItemData[] = [];
  FirstlistOfCurrentPageData: readonly ItemCheckData[] = [];
  Firstchecked: boolean = false;
  Firstindeterminate = false;
  SiteNo: any
  poItemNoList = []
  isdepartmentCharge: boolean = false
  SelectDepartdata: any
  editCache: { [key: string]: { edit: boolean; data: departDatadata } } = {};
  editDepts: { [key: string]: { edit: boolean; data: editDeptsadata } } = {};
  departData: departDatadata[] = [];
  editDeptsdata: editDeptsadata[] = [];
  headId: any
  RemarkVisible: Boolean = false;
  GetPaymentInfo: Boolean = false;
  Inv = [];
  Pay = [];
  projAndDepts = [];
  RTNOList: any[] = [];
  PaInvoicesList = [];
  PaPaymentsList = [];
  deliveryQtyTotal = new Map<string, number>();

  showSaveBtn = false;
  showApproveBtn = false;
  showRejectBtn = false;
  showDeptBtn = false;

  @Input() set index(value) {
    if (!!value || value === 0) {
      this.tabIndex = value;
    }
  };


  constructor(
    private fb: FormBuilder,
    private AuthService: AuthService,
    private Environment: EnvironmentconfigService,
    private EnvironmentconfigService: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private messageService: NzMessageService,
    private matomotracker: MatomoTracker,
    private ActivatedRoute: ActivatedRoute,
    private router: Router,
    private DatePipe: DatePipe,
    private http: HttpClient,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) { super() }


  ngOnInit() {
    this.validateForm = this.fb.group({
      aliases: this.fb.array([
      ])
    })
    this.RTDetailForm = this.fb.group({
      RTDetail: this.fb.array([
      ])
    })
    this.ActivatedRoute.queryParams.subscribe(params => {
      this.Pono = params['pono']
    })
    this.ActivatedRoute.queryParams.subscribe(params => {
      this.Currency = params['currency']
    })
    this.ActivatedRoute.queryParams.subscribe(params => {
      this.Company = params['company']
    })
    this.ActivatedRoute.queryParams.subscribe(params => {
      this.invoiceNo = params['invoice']
    })
    this.ActivatedRoute.queryParams.subscribe(params => {
      this.SiteNo = params['SiteNo']
    })
    this.ActivatedRoute.queryParams.subscribe(params => {
      this.headId = params['headId']
    })

    this.getmaintainData();
    setTimeout(() => {
      this.Firstchecked = false
    }, 50);

    this.setBtnShow();
  }

  setBtnShow() {
    this.showSaveBtn = false;
    this.showApproveBtn = false;
    this.showRejectBtn = false;
    this.showDeptBtn = false;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetWHQRole.url}`;
    this.WebApiService.doGet(url).subscribe(res => {
      const roles = res.data as string[];
      if (this.AuthService.getCurrentUserInfo().userType === 'User' && roles.some(role => ['0', '3', '4'].includes(role.toString()))) {
        this.showSaveBtn = true;
        this.showApproveBtn = true;
        this.showRejectBtn = true;
        this.showDeptBtn = true;
      }
    });
  }

  get aliases() {
    return this.validateForm.get('aliases') as FormArray;
  }

  get RTDetail() {
    return this.RTDetailForm.get('RTDetail') as FormArray;
  }

  //添加新的一条对账
  addRow() {
    this.aliases.push(
      this.fb.group(
        {
          Invoicestatus: ["TS", [Validators.required]],
          Pono: [this.Pono, [Validators.required]],
          InvoiceNo: [null, [Validators.required]],
          InvoiceDate: [null, [Validators.required]],
          Currency: [this.Currency, [Validators.required]],
          NontaxInvoiceAmount: [0, [Validators.required]],
          Taxes: [0, [Validators.required]],
          Remark: ['', [Validators.required]],
          invoicefilePath: [null, [Validators.required]],
          invoicefileName: ['', [Validators.required]],
          bind_id: [null, [Validators.required]],
          InvoiceSwitch: [false],
          invoiceType: ['manual', [Validators.required]]
        }
      )
    )


    this.SavegetmaintainData();
    console.log(this.aliases.value)
  }


  //删除一条发票信息
  deleteRow(index: any, value): void {
    this.loading = true;

    console.log(this.DetailInvoiceNoList)
    // 找到要删除的元素在数组中的索引位置
    let X: number = this.DetailInvoiceNoList.indexOf(value.InvoiceNo);

    // 如果找到了对应的索引，则删除元素
    if (X > -1) {
      this.DetailInvoiceNoList.splice(X, 1);
    }

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DeleteInvoiceItem.url}`;
    const params = {
      data: {
        headId: this.headId,
        invoiceId: value.id,
        detailId: null,
      }
    };

    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (res.status == 200) {
          this.removeFormArrayItem(index);
          this.translate.get('successfullyDelete').subscribe((translatedText: string) => {
            this.NzMessageService.success(translatedText);
          })
          this.getmaintainData();
        }
      },
      (error) => {
        this.loading = false;
      }
    );
    this.loading = false;
  }




  cancel(): void {
  }

  //删除表单组
  removeFormArrayItem(index: any) {
    this.aliases.removeAt(index);
    this.loading = false;
  }




  repeat(array) {
    for (var i = 0; i < array.length; i++) {
      for (var j = i + 1; j < array.length; j++) {
        if (array[i] === array[j]) {
          array.splice(j, 1);
          j--;
        }
      }
    }
    return array;
  }

  CompareDate(date: any): any {
    return this.DatePipe.transform(date, 'yyyy-MM-dd');

  }

  //GPA暫存对账
  SavegetmaintainData() {
    this.loading = true
    var InvoicesList = [];
    var PaymentsList = [];
    this.aliases.value.forEach((x, index) => {
      const bindId = this.aliases.at(index).get('bind_id').value;
      if (!bindId) {
        const newBindId = `${index}_${uuidv4()}`;
        this.aliases.at(index).get('bind_id').setValue(newBindId);
      }
    });
    var key: boolean = false
    this.aliases.value.forEach((x, index) => {
      if (x.InvoiceDate != null) {
        x.InvoiceDate = this.CompareDate(x.InvoiceDate);
      }
      if (!(/^\d+(\.\d+)?$/.test(x.NontaxInvoiceAmount.toString()))) {
        return key = true;
      }
      if (!(/^\d+(\.\d+)?$/.test(x.Taxes.toString()))) {
        return key = true;
      }
      var alias = {
        bind_id: x.bind_id,
        poItemNo: x.Pono,
        rtNo: x.rtNo,
        rtItemNo: x.rtItemNo,
        itemNo: x.itemNo,
        invoiceNo: x.InvoiceNo,
        invoiceDate: x.InvoiceDate,
        expectDueDate: x.ExpectDueDate ? this.CompareDate(x.ExpectDueDate) : null,
        amount: x.NontaxInvoiceAmount,
        tax: x.Taxes,
        remark: x.Remark,
        Id: x.id,
        invoiceType: x.invoiceType
      };
      InvoicesList.push(alias);
    });
    this.RTDetail.value.forEach(o => {
      if (!(/^\d+(\.\d+)?$/.test(o.NotTaxAmount.toString()))) {
        return key = true;
      }
      if (!(/^\d+(\.\d+)?$/.test(o.PATax.toString()))) {
        return key = true;
      }
      const matchInvoice = this.aliases.value.find(invoice => invoice.InvoiceNo === o.DetailInvoiceNo);
      if (matchInvoice != undefined) {
        var alias = {
          detail_id: o.detail_id,
          itemNo: o.itemNo,
          invoiceNo: o.DetailInvoiceNo,
          poNo: o.Pono,
          poItemNo: o.poItemNo,
          invoiceDate: matchInvoice.InvoiceDate,
          amount: o.NotTaxAmount,
          tax: o.PATax,
          poQty: o.poQty,
          unpaidQty: o.unpaidQty,
          deliveryQty: o.deliveryQty,
          invoice_bindid: matchInvoice.bind_id,
          itemDesc: o.itemDesc,
        };
        PaymentsList.push(alias);
      }
    })
    if (key) {
      this.loading = false
      this.translate.get('TheAmountIsPunctuated').subscribe((translatedText: string) => {
        return this.NzMessageService.warning(translatedText);
      })
    }
    const params = {
      data: {
        companyNo: this.Company,
        siteNo: this.SiteNo,
        poNo: this.Pono,
        invoiceType: '',
        applicationhead: {
          remark: InvoicesList.map(y => y.remark).join(';')
        },
        PaymentsList: PaymentsList,
        InvoicesList: InvoicesList
      }
    };

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.TemporaryStorage.url}`;
    this.WebApiService.doPost(url, params).subscribe(
      async (res) => {
        // 在函数体中处理响应数据
        if (res.status == 200) {
          this.translate.get('TemporarySuccess').subscribe((translatedText: string) => {
            this.NzMessageService.success(translatedText);
          })
          if (res.data != null) {
            this.headId = res.data
          }
          await this.getmaintainData()
          this.loading = false
        } else {

          this.NzMessageService.warning(res.msg)
          this.loading = false
        }

      },
      (error) => {
        // 在函数体中处理错误
        this.loading = false
        console.log(error);
      }
    );
  }


  //新加载该PO下的所有发票与明细
  getmaintainData() {
    this.loading = true
    this.FirstsetOfCheckedId.clear();
    this.Firstchecked = false;
    this.Firstindeterminate = false;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetPolnDetailList.url}`;
    const params = {
      data:
      {
        siteNo: this.SiteNo,
        poNo: this.Pono,
        headId: this.headId
      }
    };
    this.WebApiService.doPost(url, params).toPromise().then((res) => {
      this.aliases.clear();
      this.RTDetail.clear();
      if (res.invoicesList != null) {
        console.log(res.polnList)
        this.poItemNoList = res.polnList.map(item => item.poln);
        //加载该PO下的发票
        this.aliases.clear();


        res.invoicesList.forEach(o => {
          let status
          if (o.status == null) {
            status = "TS"
          } else {
            status = o.status
          }

          let InvoiceSwitch: boolean;
          if (o.invoiceType == "manual" || o.invoiceType == null) {
            InvoiceSwitch = false
          } else {
            InvoiceSwitch = true
          }
          this.aliases.push(
            this.fb.group(
              {
                Pono: [this.Pono],
                bind_id: [o.bind_id],
                poItemNo: [o.poItemNo],
                rtNo: [o.rtNo],
                rtItemNo: [o.rtItemNo],
                itemNo: [o.itemNo],
                InvoiceNo: [o.invoiceNo, [Validators.required]],
                InvoiceDate: [o.invoiceDate, [Validators.required]],
                ExpectDueDate: [o.expectDueDate, [Validators.required]],
                NontaxInvoiceAmount: [o.amount, [Validators.required]],
                Taxes: [o.tax, [Validators.required]],
                Invoicestatus: [status, [Validators.required]],
                id: [o.id, [Validators.required]],
                invoicefilePath: [o.invoiceElectronic],
                invoicefileName: [o.invoiceElectronicName],
                otherfilePath: [o.otherAttachment],
                otherInvoicefileName: [o.otherAttachmentName],
                buyerOtherFiles: [o.purchaseAttachment],
                buyerOtherFilesfileName: [o.purchaseAttachmentName],
                Remark: [o.remark, [Validators.required]],
                invoiceType: [o.invoiceType],
                InvoiceSwitch: [InvoiceSwitch],
                Currency: [this.Currency]
              }

            )
          )
          this.listOfCurrentPageData = this.aliases.value
          this.FirstlistOfCurrentPageData = this.aliases.value
          console.log(this.aliases.value, " this.aliases.value")
          this.DetailInvoiceNoList = Array.from(new Set(this.DetailInvoiceNoList));

        });
        //加载该PO下的明细
        this.RTDetail.clear();
        res.paymentsList.forEach((o, index) => {
          this.RTDetail.push(
            this.fb.group(
              {
                detail_id: [o.detail_id],
                Pono: [o.poNo, [Validators.required]],
                DetailInvoiceNo: [o.invoiceNo, [Validators.required]],
                poItemNo: [o.poItemNo, [Validators.required]],
                itemNo: [o.itemNo, [Validators.required]],
                invoiceDate: [o.invoiceDate, [Validators.required]],
                NotTaxAmount: [o.amount, [Validators.required]],
                PATax: [o.tax, [Validators.required]],
                poQty: [o.poQty, [Validators.required]],
                unpaidQty: [o.unpaidQty, [Validators.required]],
                price: [o.price, [Validators.required]],
                deliveryQty: [o.qty, [Validators.required]],
                invoice_bindid: [o.invoice_bindid, [Validators.required]],
                itemDesc: [o.itemDesc, [Validators.required]],
                amount: [, [Validators.required]],
              }

            )
          )
          this.RTDetail.value[index].DetailInvoiceNo = o.invoiceNo
        })
        this.RTDetail.controls.forEach((control, index) => {
          const poItemNo = control.get('poItemNo').value;
          const foundItem = res.polnList.find(item => item.poln === poItemNo);
          if (foundItem) {
            control.patchValue({
              amount: foundItem.amount,
              poQty: foundItem.poQty,
              unpaidQty: foundItem.notRtQty,
              price: foundItem.price
            });
          }
        });
        this.SelectInvoiceNo()
        this.loading = false;
      } else {
        this.loading = false;
      }

    });
  }



  //新GPA提交按钮
  async WHQSubmitList() {

    this.loading = true
    var list = [];
    var CorrectAmount: Boolean = false
    this.FirstsetOfCheckedId.forEach(O => {
      var dto = this.aliases.value.find(o => o.bind_id == O);
      if (dto != undefined) {
        list.push(dto);
      }
    })
    if (list.length == 0) {
      this.loading = false
      this.translate.get('PleaseCheckData').subscribe((translatedText: string) => {
        return this.NzMessageService.warning(translatedText);
      })
      return
    }

    // 校验逻辑升级：精准提示错误
    // if (await this.Submitdisabled()) {
    //   return this.loading = false
    // }
    let hasError = false;
    for (let i = 0; i < list.length; i++) {
        const item = list[i];
        // 找到该条数据在 aliases 中的索引，用于提示是"第几行"
        // 注意：aliases 是 FormArray，其 value 是对象数组。list 也是对象数组。
        // 由于 item 是从 aliases.value 中 find 出来的引用，或者是 copy?
        // aliases.value 返回的是对象的 copy 还是 reference? 通常是 copy，但是这里的数据源 FirstlistOfCurrentPageData 也是来自 aliases.value
        // 最好通过 bind_id 来查找准确的行号
        const rowIndex = this.aliases.value.findIndex(x => x.bind_id === item.bind_id) + 1;
        let errorMsg = '';

        // 1. 校验 Invoice No
        if (!item.InvoiceNo) {
            errorMsg = `第 ${rowIndex} 行: 发票号码(Invoice No)必填`;
        } else if (item.Currency == "NTD") {
             if (!/^[a-zA-Z]{2}\d{8}$/.test(item.InvoiceNo)) {
                 errorMsg = `第 ${rowIndex} 行: NTD 发票号码格式错误 (需为2位字母+8位数字)`;
             }
        }

        // 2. 校验 Invoice Date
        if (!errorMsg && !item.InvoiceDate) {
             errorMsg = `第 ${rowIndex} 行: 发票日期(Invoice Date)必填`;
        }

        // 3. 校验 Amount (简单判断不能为0)
        // 注意: 前面有用正则 /^\d+(\.\d+)?$/ 校验数字格式的逻辑，这里先只看值
        if (!errorMsg) {
             if (!item.NontaxInvoiceAmount || item.NontaxInvoiceAmount == 0) {
                 errorMsg = `第 ${rowIndex} 行: 未税金额(Invoice Amount)必填且不能为0`;
             }
        }

        // 4. 校验 文件上传
        if (!errorMsg) {
             if (!item.invoicefilePath) {
                 errorMsg = `第 ${rowIndex} 行:必须上传发票文件(Electronic Invoice File)`;
             }
        }

        if (errorMsg) {
            this.NzMessageService.warning(errorMsg);
            hasError = true;
            // 如果希望一次只报一个错，可以在这里 break; 或者 allow multiple?
            // 既然是精准提示，先报第一个错让用户改
            break;
        }
    }

    if (hasError) {
        this.loading = false;
        return;
    }

    // 原有逻辑：校验金额小数点
    for (let t of list) {
      const InvoiceAmount = Number(t.NontaxInvoiceAmount) + Number(t.Taxes);

      if (this.Currency == "NTD" && !Number.isInteger(InvoiceAmount)) {
        this.translate.get('NTDInvoiceAmountCannotHaveDecimalPoints').subscribe((translatedText: string) => {
          return this.NzMessageService.error(translatedText);
        });
        this.loading = false;
        CorrectAmount = true;
        break; // 跳出循环
      }

      if (this.Currency != "NTD") {
        const decimalPart = InvoiceAmount.toString().split('.')[1]; // 获取小数部分
        if (decimalPart == undefined) {
          if (this.Currency != "NTD" && !(/^\d+(\.\d{1,2})?$/.test(InvoiceAmount.toString()))) {
            this.translate.get('NotNTD').subscribe((translatedText: string) => {
              return this.NzMessageService.error(translatedText);
            });
            this.loading = false;
            CorrectAmount = true;
            break; // 跳出循环

          }
        } else {
          if (decimalPart.length > 10) {
            const result = Math.round(InvoiceAmount * 100) / 100
            if (this.Currency != "NTD" && !(/^\d+(\.\d{1,2})?$/.test(result.toString()))) {
              this.translate.get('NotNTD').subscribe((translatedText: string) => {
                return this.NzMessageService.error(translatedText);
              });
              this.loading = false;
              CorrectAmount = true;
              break; // 跳出循环

            }
          } else {
            if (this.Currency != "NTD" && !(/^\d+(\.\d{1,2})?$/.test(InvoiceAmount.toString()))) {
              this.translate.get('NotNTD').subscribe((translatedText: string) => {
                return this.NzMessageService.error(translatedText);
              });
              this.loading = false;
              CorrectAmount = true;
              break; // 跳出循环

            }
          }
        }
      }
    }
    if (CorrectAmount) {
      return
    }
    var InvoicesList = [];
    var PaymentsList = [];
    var data = [];
    this.FirstsetOfCheckedId.forEach(O => {
      var dto = this.aliases.value.find(o => o.bind_id == O);
      data.push(dto);
    })
    var key: boolean = false
    data.forEach((x, index) => {
      if (x.InvoiceDate != null) {
        x.InvoiceDate = this.CompareDate(x.InvoiceDate);
      }
      if (x.InvoiceDate != null) {
        x.InvoiceDate = this.CompareDate(x.InvoiceDate);
      }
      if (!(/^\d+(\.\d+)?$/.test(x.NontaxInvoiceAmount.toString()))) {
        return key = true;
      }
      if (!(/^\d+(\.\d+)?$/.test(x.Taxes.toString()))) {
        return key = true;
      }
      var alias = {
        bind_id: x.bind_id,
        poItemNo: x.Pono,
        rtNo: x.rtNo,
        rtItemNo: x.rtItemNo,
        itemNo: x.itemNo,
        invoiceNo: x.InvoiceNo,
        invoiceDate: x.InvoiceDate,
        expectDueDate: x.ExpectDueDate ? this.CompareDate(x.ExpectDueDate) : null,
        amount: x.NontaxInvoiceAmount,
        tax: x.Taxes,
        Id: x.id,
        remark: x.Remark,
        invoiceType: x.invoiceType
      };
      InvoicesList.push(alias);
    });

    this.RTDetail.value.filter(o => o.poItemNo != null).forEach(o => {
      if (!(/^\d+(\.\d+)?$/.test(o.NotTaxAmount.toString()))) {
        return key = true;
      }
      if (!(/^\d+(\.\d+)?$/.test(o.PATax.toString()))) {
        return key = true;
      }
      const matchInvoice = data.find(invoice => invoice.InvoiceNo === o.DetailInvoiceNo);
      if (matchInvoice != undefined) {

        var alias = {
          detail_id: o.detail_id,
          itemNo: o.itemNo,
          invoiceNo: o.DetailInvoiceNo,
          poNo: o.Pono,
          poItemNo: o.poItemNo,
          invoiceDate: matchInvoice.InvoiceDate,
          amount: o.NotTaxAmount,
          tax: o.PATax,
          poQty: o.poQty,
          unpaidQty: o.unpaidQty,
          deliveryQty: o.deliveryQty,
          invoice_bindid: matchInvoice.bind_id,
          itemDesc: o.itemDesc,
        };
        PaymentsList.push(alias);
      }
    })
    if (key) {
      this.loading = false
      this.translate.get('TheAmountIsPunctuated').subscribe((translatedText: string) => {
        return this.NzMessageService.warning(translatedText);
      })
      return
    }
    if (PaymentsList.length == 0) {
      this.loading = false
      this.translate.get('PoItemdetail').subscribe((translatedText: string) => {
        return this.NzMessageService.warning(translatedText);
      })
      return

    }
    const params = {
      data: {
        companyNo: this.Company,
        siteNo: this.SiteNo,
        poNo: this.Pono,
        invoiceType: InvoicesList[0].invoiceType,
        applicationhead: {},
        PaymentsList: PaymentsList,
        InvoicesList: InvoicesList
      }
    };

    const url1 = `${this.Environment.authConfig.wmsmUrl}${URLConst.TemporaryStorage.url}`;

    this.WebApiService.doPost(url1, params).subscribe(
      (res) => {
        const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.SubmitAsync.url}`;

        this.WebApiService.doPost(url, params).subscribe(
          (res) => {
            if (res.status == 200) {
              this.NzMessageService.success(res.msg);
              this.getmaintainData();
              this.loading = false
            } else {
              this.NzMessageService.warning(res.msg);
              this.loading = false
            }

          },
          (error) => {
            this.loading = false;
          })
      },
      (error) => {
        this.loading = false;
      });


  }



  //返回维护界面
  Retrun() {
    this.router.navigate(["/pages/wmsm-pages/SupplierManagement/StatementPaymentManagementWHQ/wmsmStatementMaintainWHQ"]);
  }

  //下载发票模板
  exportTableToExecl() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DownloadGPAInvoiceTemplate.url}`;
    const param = {};
    this.WebApiService.doPost(url, param, true).subscribe((res) => {
      this.loading = false;
    });
  }

  //下载明细模板
  exportDetailExecl() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DownloadDetailInformationTemplate.url}`;
    const param = {};
    this.WebApiService.doPost(url, param, true).subscribe((res) => {
      this.loading = false;
    });
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    this.saveExcelData(file);
    return false;
  };


  beforeUploadFile = async (file: NzUploadFile) => {
    if (file.size > 1024 * 1024 * 10) {
      this.translate.get('FileSizeIsTooLarge').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
      return false;
    }

    this.Uploadfile(file);
  };

  //Upload发票批量上传
  saveExcelData(file) {
    this.loading = true;
    const formData = new FormData();
    formData.append('file', file);
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UploadInvoiceTemplateExcel.url}?PoNo=` + this.Pono + '&siteno=' + this.SiteNo;
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    this.http
      .request(req)
      .pipe(filter((e) => e instanceof HttpResponse))
      .subscribe(

        (res) => {
          this.getmaintainData();
          this.aliases.clear();
          this.NzMessageService.success(((res as any).body && (res as any).body.msg) || 'Success');
          this.loading = false;
        },
        (error) => {
          this.translate.get('UploadFailed').subscribe((translatedText: string) => {
            this.NzMessageService.error(translatedText);
          })
          this.loading = false;
        }
      );
  }


  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    differenceInCalendarDays(current, this.today) > 0;

  disabledExpectDueDate = (current: Date): boolean =>
    differenceInCalendarDays(current, this.today) <= 4;

  //切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    // this.getResultData();
  }
  //切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    // this.getResultData();
  }



  //上传发票文件
  Uploadfile(file) {
    this.loading = true;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('purpose', 'invoicefile');
    formData.append('invoiceId', this.rowID);
    formData.append('id', this.headId);
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GPAUploadFile.url}?PoNo=` + this.Pono + '&Invoice=' + this.InvoiceNodata;
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    this.http.request(req).pipe(filter((e) => e instanceof HttpResponse)).subscribe(
      (res) => {
        this.SavegetmaintainData()
        this.loading = false;
      },
      (error) => {
        this.translate.get('UploadFailed').subscribe((translatedText: string) => {
          this.NzMessageService.error(translatedText);
        })
        this.loading = false;
      }
    );
  }

  Submitdisabled() {

    let subitdisablebbutton = true;
    var data = [];
    this.FirstsetOfCheckedId.forEach(O => {
      var dto = this.aliases.value.find(o => o.bind_id == O);
      if (dto != undefined) {
        data.push(dto);
      }
    })
    let terminateLoop = false;
    if (data.length > 0) {
      data.forEach(item => {
        if (terminateLoop) {
          return;
        }
        if (item.Currency == "NTD") {
          this.booleaninvoiceno = (new RegExp(/^[a-zA-Z]{2}\d{8}$/).test(item.InvoiceNo))
          if (item.InvoiceDate != null && this.booleaninvoiceno == true && item.NontaxInvoiceAmount != 0 && (item.invoicefilePath != null && item.invoicefilePath != "")) {
            subitdisablebbutton = false;
            return subitdisablebbutton;
          } else {
            subitdisablebbutton = true;
            this.translate.get('SubmitdisabledMsg').subscribe((translatedText: string) => {
              this.NzMessageService.warning(translatedText)
            });
            terminateLoop = true;
          }
        }
        if (item.Currency != "NTD") {
          if (item.InvoiceDate != null && item.InvoiceNo != "" && item.NontaxInvoiceAmount != 0 && (item.invoicefilePath != null && item.invoicefilePath != "")) {
            subitdisablebbutton = false;
            return subitdisablebbutton;
          }
          else {
            subitdisablebbutton = true;
            subitdisablebbutton = true;
            this.translate.get('SubmitdisabledMsg').subscribe((translatedText: string) => {
              this.NzMessageService.warning(translatedText)
            });
            terminateLoop = true;
          }
        }
      }
      );
    } else {
      subitdisablebbutton = true
    }
    return subitdisablebbutton;
  }


  SelectFiledisabled() {
    let Filedisabled = true;
    this.aliases.value.forEach(item => {
      if (item.InvoiceDate != null && item.InvoiceNo != "" && item.NontaxInvoiceAmount != 0 && item.Taxes != "") {
        Filedisabled = false
        return Filedisabled;
      }
    }
    );
    return Filedisabled;
  }

  InvoiceNoMsgShow(note: string): void {
    if (note == 'InvoiceNo') {
      this.InvoiceNoChange
    }
  }

  InvoiceNoChange(value, index) {

    this.loading = true;
    this.ChangeValue = value;
    var InvoiceNodate = this.DatePipe.transform(DateUtil.formatYMD(value.InvoiceDate), 'yyyy-MM-dd')
    this.checkboolean = true;
    //  (new RegExp(/^[a-zA-Z]{2}\d{8}$/).test(value.InvoiceNo));
    if (InvoiceNodate == null) {
      this.translate.get('PleaseFillInTheInvoiceDate').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
      setTimeout(() => {
        const control = this.aliases.controls[index];
        control.patchValue({
          invoiceType: "manual",
          InvoiceSwitch: false
        });
      }, 20);

      this.loading = false;
      return
    }
    if (this.checkboolean) {
      this.loading = true
      const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.WHQQueryInvoicPool.url}`;
      const params = {
        data: {
          invoiceKey: value.InvoiceNo + '_' + InvoiceNodate,
          invoiceNoList: [],
          moduleId: "",
          supplierCode: "",
          companyNoErp: "",
          siteNo: this.SiteNo,
          PONO: value.Pono
        },
      };

      this.WebApiService.doPost(url, params).subscribe(
        async (res) => {
          if (res.msg != null) {
            this.NzMessageService.warning(res.msg);
            const control = this.aliases.controls[index];
            control.patchValue({
              InvoiceSwitch: false
            });
            this.loading = false;
          } else {
            if (res.data.data.length == 0) {
              this.translate.get('NotInTheInvoicePoolOrTheInvoiceIsInvalid').subscribe((translatedText: string) => {
                this.NzMessageService.warning(translatedText);
              })
              const control = this.aliases.controls[index];
              control.patchValue({
                invoiceType: "manual",
                InvoiceSwitch: false
              });
              this.InvoiceSwitch("manual", value)
              this.loading = false
              return;
            }
            else {
              this.translate.get('InvoicesHaveBeenFoundInTheInvoicePool').subscribe((translatedText: string) => {
                this.NzMessageService.success(translatedText);
              })
              if (this.Currency == 'NTD') {
                this.aliases.value[index].Taxes = res.data.data[0].tax;
                this.aliases.value[index].NontaxInvoiceAmount = res.data.data[0].totalSalesAmount;
                console.log(this.aliases.value[index])
                //this.SavegetmaintainData();
                const control = this.aliases.controls[index];
                control.patchValue({
                  invoiceType: "twEinv",
                  InvoiceSwitch: true,
                  Taxes: res.data.data[0].tax,
                  NontaxInvoiceAmount: res.data.data[0].totalSalesAmount
                });
              } else {
                // this.aliases.value[index].Taxes = res.data.data[0].tax;
                // this.aliases.value[index].NontaxInvoiceAmount = res.data.data[0].totalSalesAmount;
                this.translate.get('PleaseEnterInvoiceAmountAndTaxInPOCurrency').subscribe((translatedText: string) => {
                  this.NzMessageService.info(translatedText, { nzDuration: 10000 });
                })
                console.log(this.aliases.value[index])
                //this.SavegetmaintainData();
                const control = this.aliases.controls[index];
                control.patchValue({
                  invoiceType: "twEinv",
                  InvoiceSwitch: true,
                  // Taxes: res.data.data[0].tax,
                  // NontaxInvoiceAmount: res.data.data[0].totalSalesAmount
                });
              }

              this.InvoiceSwitch("twEinv", value)
              await this.SavegetmaintainData()
              this.loading = false;
            }
          }
          this.loading = false;
        })
    }
    else {
      this.translate.get('PleaseCheckInvoice').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
      setTimeout(() => {
        const control = this.aliases.controls[index];
        control.patchValue({
          invoiceType: "manual",
          InvoiceSwitch: false
        });
      }, 20);
      this.loading = false;
    }
  }

  CloseInput(note: string): void {
    if (this.ChangeValue.Currency == "NTD") {
      this.booleaninvoiceno = (new RegExp(/^[a-zA-Z]{2}\d{8}$/).test(this.ChangeValue.InvoiceNo));

      if (this.booleaninvoiceno == false) {
        let msg1: string = '';
        let msg2: string = '';
        this.translate.get('InvoiceNo').subscribe((translatedText: string) => {
          msg1 = translatedText;
        });
        this.translate.get('InvoiceMsg').subscribe((translatedText: string) => {
          msg2 = translatedText;
        });
        this.NzMessageService.warning(msg1 + this.ChangeValue.InvoiceNo + msg2, {
          nzDuration: 2000
        });
      }
    }
  }


  GetLanguage() {
    if (sessionStorage.getItem("wmsmlang") == "zh-CN") {
      this.cn = true;
      this.tw = false;
      this.en = false;
    }
    if (sessionStorage.getItem("wmsmlang") == "zh-TW") {
      this.tw = true;
      this.cn = false;
      this.en = false;
    }
    if (sessionStorage.getItem("wmsmlang") == "en") {
      this.en = true;
      this.cn = false;
      this.tw = false;
    }

  }

  //下载发票文件
  GetFileTokenOnClick(data) {
    this.WebApiService.downloadFileByToken(data.value.invoicefilePath).subscribe(
      (res) => {
        this.downloadFile8(res, data.value.invoicefileName);
        this.NzMessageService.success(res.msg);

      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );
  }
  //下载副档文件
  GetOtherFileTokenOnClick(data) {
    this.WebApiService.downloadFileByToken(data.value.otherfilePath).subscribe(
      (res) => {
        this.downloadFile8(res, data.value.otherInvoicefileName);
        this.NzMessageService.success(res.msg);

      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );
  }



  //删除发票文件
  DeleteUploadFile(data) {

    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GPADeleteUploadFile.url}`;
    const params = {
      data:
      {
        invoiceId: data.value.id,
        headId: this.headId,
        type: "invoicefile"
      }
    };
    this.WebApiService.doPost(url, params,).subscribe(
      (res) => {
        if (res.status == 200) {
          this.translate.get('successfullyDelete').subscribe((translatedText: string) => {
            this.NzMessageService.success(res.msg + translatedText);
          })
          this.getmaintainData();
        }
        else {
          this.translate.get('FailToDelete').subscribe((translatedText: string) => {
            this.NzMessageService.error(res.msg + translatedText);
          })
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );

  }
  //删除副档文件
  DeleteUploadOtherFile(data) {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GPADeleteUploadFile.url}`;
    const params = {
      data:
      {
        invoiceId: data.value.id,
        headId: this.headId,
        type: "invoiceOtherFile"
      }
    };
    this.WebApiService.doPost(url, params,).subscribe(
      (res) => {
        if (res.status == 200) {
          this.translate.get('successfullyDelete').subscribe((translatedText: string) => {
            this.NzMessageService.success(res.msg + translatedText);
          })
          this.getmaintainData();
        }
        else {
          this.translate.get('FailToDelete').subscribe((translatedText: string) => {
            this.NzMessageService.error(res.msg + translatedText);
          })
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );

  }


  GetRowInfo(value, index) {
    this.InvoiceNodata = value.InvoiceNo
    this.rowID = value.id;
  }



  //上传副档文件
  beforeUploadOtherFile = (file: NzUploadFile) => {
    if (file.size > 1024 * 1024 * 10) {

      this.translate.get('FileSizeIsTooLarge').subscribe((translatedText: string) => {
        this.NzMessageService.error(translatedText);
      })
      return false;
    }

    this.UploadOtherFile(file);
  }
  //上传副档文件
  UploadOtherFile(file) {
    this.loading = true
    const formData = new FormData();
    formData.append('file', file);
    formData.append('purpose', 'invoiceOtherFile');
    formData.append('invoiceId', this.rowID);
    formData.append('id', this.headId);
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GPAUploadFile.url}?PoNo=` + this.Pono + '&Invoice=' + this.InvoiceNodata;
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    this.http.request(req).pipe(filter((e) => e instanceof HttpResponse)).subscribe
      (
        (res) => {
          this.SavegetmaintainData()
          this.loading = false
        },
        (error) => {
          this.translate.get('UploadFailed').subscribe((translatedText: string) => {
            this.NzMessageService.error(translatedText);
          })
          this.loading = false;
        }
      );

  }
  //下载采购附档
  GetBuyerOtherFile(data) {
    this.WebApiService.downloadFileByToken(data.value.buyerOtherFiles).subscribe(
      (res) => {
        this.downloadFile8(res, data.value.buyerOtherFilesfileName);
        this.NzMessageService.success(res.msg);

      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );
  }



  //上传采购附檔文件
  beforeBuyerOtherFiles = (file: NzUploadFile) => {
    if (file.size > 1024 * 1024 * 10) {
      this.translate.get('FileSizeIsTooLarge').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
      return false;
    }

    this.UploadBuyerOtherFiles(file);
  }

  //上传采购副档文件
  UploadBuyerOtherFiles(file) {
    this.loading = true;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('purpose', 'BuyerOtherFiles');
    formData.append('invoiceId', this.rowID);
    formData.append('id', this.headId);
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GPAUploadFile.url}?PoNo=` + this.Pono + '&Invoice=' + this.InvoiceNodata;
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    this.http.request(req).pipe(filter((e) => e instanceof HttpResponse)).subscribe(
      (res) => {
        this.SavegetmaintainData()
        this.loading = false;
      },
      (error) => {
        this.translate.get('UploadFailed').subscribe((translatedText: string) => {
          this.NzMessageService.error(translatedText);
        })
        this.loading = false;
      }
    );
  }

  //删除采购副档文件
  DeleteBuyerOtherFiles(data) {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GPADeleteUploadFile.url}`;
    const params = {
      data:
      {
        invoiceId: data.value.id,
        headId: this.headId,
        type: "BuyerOtherFiles"
      }
    };
    this.WebApiService.doPost(url, params,).subscribe(
      (res) => {
        if (res.status == 200) {
          this.translate.get('successfullyDelete').subscribe((translatedText: string) => {
            this.NzMessageService.success(res.msg + translatedText);
          })
          this.getmaintainData();
        }
        else {
          this.translate.get('FailToDelete').subscribe((translatedText: string) => {
            this.NzMessageService.error(res.msg + translatedText);
          })
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );

  }

  ngModelChange(value) {

    this.RTDetail.value.forEach((p, index) => {
      if (p.invoice_bindid == value.bind_id) {

        console.log(this.DetailInvoiceNoList)
        // 找到要删除的元素在数组中的索引位置
        let X: number = this.DetailInvoiceNoList.indexOf(p.DetailInvoiceNo);

        // 如果找到了对应的索引，则删除元素
        if (X > -1) {
          this.DetailInvoiceNoList.splice(X, 1);
          this.RTDetail.controls[index].get('DetailInvoiceNo').setValue(null);
        }

      }
    })
  }




  //添加新的一条明细
  addDetail(): void {
    this.RTDetail.push(
      this.fb.group(
        {
          Pono: [this.Pono, [Validators.required]],
          DetailInvoiceNo: [null, [Validators.required]],
          poItemNo: [null, [Validators.required]],
          itemNo: [null, [Validators.required]],
          invoiceDate: [null, [Validators.required]],
          NotTaxAmount: [0, [Validators.required]],
          poQty: [0, [Validators.required]],
          unpaidQty: [0, [Validators.required]],
          deliveryQty: [0, [Validators.required]],
          PATax: [0, [Validators.required]],
          invoice_bindid: [null, [Validators.required]],
          amount: [0, [Validators.required]],
          price: [0, [Validators.required]],
        }
      )
    )

  }

  //删除一条明细
  deleteDetail(index: any, value): void {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DeleteInvoiceItem.url}`;
    const params = {
      data: {
        headId: this.headId,
        invoiceId: null,
        detailId: value.detail_id,
      }
    };

    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (res.status == 200) {
          this.removeRTDetailFormItem(index);
          this.translate.get('successfullyDelete').subscribe((translatedText: string) => {
            this.NzMessageService.success(translatedText);
          })
          this.getmaintainData();
        }
      },
      (error) => {
        this.loading = false;
      }
    );
    this.loading = false;
  }



  //删除表单组
  removeRTDetailFormItem(index: any) {
    this.RTDetail.removeAt(index);

  }
  SelectInvoiceNo() {
    this.DetailInvoiceNoList = []
    this.aliases.value.forEach(x => {
      if ((x.InvoiceNo != null && x.InvoiceNo != "") && !this.DetailInvoiceNoList.includes(x.InvoiceNo)) {
        this.DetailInvoiceNoList.push(x.InvoiceNo)
      }
    });

  }


  async SelectInvoiceNoChange(): Promise<void> {
    await this.SavegetmaintainData();
  }

  //复制按钮
  async AsFirst(value: String) {
    if (value === "InvoiceNo") {

      if (this.RTDetail.value[0].DetailInvoiceNo != null) {
        this.RTDetail.value.forEach(x => {
          x.DetailInvoiceNo = this.RTDetail.value[0].DetailInvoiceNo
        })
        await this.SavegetmaintainData();
      }
    }
    if (value === "InvoiceDate") {
      if (this.aliases.value[0].InvoiceDate != null) {
        this.aliases.value.forEach(x => {
          x.InvoiceDate = this.aliases.value[0].InvoiceDate
        })
      }
      for (let i = 0; i < this.aliases.length; i++) {
        this.aliases.controls[i].get('InvoiceDate').setValue(this.aliases.value[0].InvoiceDate);
      }

    }
    if (value === "poQty") {
      this.RTDetail.value.forEach(x => {
        x.deliveryQty = x.poQty
      })
      for (let i = 0; i < this.RTDetail.length; i++) {
        this.RTDetail.controls[i].get('deliveryQty').setValue(this.RTDetail.value[i].deliveryQty);
      }
    }
  }




  //提交数据勾选
  FirstPageDataChange($event: readonly ItemData[]): void {
    this.FirstCheckedStatus();
  }

  FirstCheckedStatus(): void {
    this.Firstchecked = this.FirstlistOfCurrentPageData.every(item => this.FirstsetOfCheckedId.has(item.bind_id));
    this.Firstindeterminate = this.FirstlistOfCurrentPageData.some(item => this.FirstsetOfCheckedId.has(item.bind_id)) && !this.Firstchecked;
  }

  FirstonItemChecked(id: number, Firstchecked: boolean, index: number): void {
    this.FirstupdateCheckedSet(id, Firstchecked, index);
    this.FirstCheckedStatus();
  }

  FirstonAllChecked(Firstchecked: boolean): void {

    var i: number
    this.FirstlistOfCurrentPageData.forEach(item => this.FirstupdateCheckedSet(item.bind_id, Firstchecked, i));
    this.FirstCheckedStatus();
  }

  FirstupdateCheckedSet(id: number, Firstchecked: boolean, index: number): void {
    if (Firstchecked) {
      this.FirstsetOfCheckedId.add(id);
    } else {
      this.FirstsetOfCheckedId.delete(id)
    }
  }



  //選擇POitem
  poItemNoChange(value, index, Input) {
    const params = {
      data: {
        siteNo: this.SiteNo,
        poln: value.poItemNo,
        poNo: this.Pono,
      }
    }
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetPolnList.url}`;
    this.WebApiService.doPost(url, params,).subscribe(
      (res) => {

        const control = this.RTDetail.controls[index];
        control.patchValue({
          amount: res[0].amount,
          unpaidQty: res[0].notRtQty,
          poQty: res[0].poQty,
          price: res[0].price,
          itemDesc: res[0].itemDesc
        });
      },
      (error) => {

      }
    );
  }

  //填写实际交货数量
  deliveryQtyChange(Input, value, index) {
    if (Input < 0) {
      Input = 0;
      const control = this.RTDetail.controls[index];
      control.patchValue({
        deliveryQty: 0
      });
    }
    this.RTDetail.value[index].NotTaxAmount = parseFloat(((value.price * Input) - (((value.price * Input) / 1.05) * 0.05)).toFixed(2));
    this.RTDetail.value[index].PATax = parseFloat((((value.price * Input) / 1.05) * 0.05).toFixed(2));

    const control = this.RTDetail.controls[index];
    control.patchValue({
      NotTaxAmount: this.RTDetail.value[index].NotTaxAmount,
      PATax: this.RTDetail.value[index].PATax
    });

    this.RTDetail.value.forEach(o => {
      const matchInvoice = this.aliases.value.find(invoice => invoice.InvoiceNo === o.DetailInvoiceNo);
      if (matchInvoice) {
        o.invoice_bindid = matchInvoice.bind_id;
      }
    })


  }


  //Revocation撤回按钮
  Revocation() {
    var InvoicesList = [];
    var PaymentsList = [];
    var data = [];
    // this.FirstsetOfCheckedId.forEach(O=>{
    //   var dto = this.aliases.value.find(o => o.bind_id == O);
    //   data.push(dto);
    // })
    this.aliases.value.forEach((x, index) => {
      if (x.InvoiceDate != null) {
        x.InvoiceDate = this.CompareDate(x.InvoiceDate);
      }
      var alias = {
        bind_id: x.bind_id,
        poItemNo: x.Pono,
        rtNo: x.rtNo,
        rtItemNo: x.rtItemNo,
        itemNo: x.itemNo,
        invoiceNo: x.InvoiceNo,
        invoiceDate: x.InvoiceDate,
        amount: x.NontaxInvoiceAmount,
        tax: x.Taxes,
        Id: x.id,
        invoiceType: x.invoiceType
      };
      InvoicesList.push(alias);
    });


    this.RTDetail.value.forEach(o => {

      const matchInvoice = this.aliases.value.find(invoice => invoice.InvoiceNo === o.DetailInvoiceNo);

      var alias = {
        detail_id: o.id,
        itemNo: o.itemNo,
        invoiceNo: o.DetailInvoiceNo,
        poNo: o.Pono,
        poItemNo: o.poItemNo,
        invoiceDate: matchInvoice.InvoiceDate,
        amount: o.NotTaxAmount,
        tax: o.PATax,
        poQty: o.poQty,
        unpaidQty: o.unpaidQty,
        deliveryQty: o.deliveryQty,
        invoice_bindid: matchInvoice.bind_id,
        itemDesc: o.itemDesc,
      };
      PaymentsList.push(alias);

    })
    const params = {
      data: {
        companyNo: this.Company,
        siteNo: this.SiteNo,
        poNo: this.Pono,
        invoiceType: '',
        applicationhead: {},
        PaymentsList: PaymentsList,
        InvoicesList: InvoicesList
      }
    };

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.RollbackToDraft.url}`;

    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        this.translate.get('SuccessfulWithdrawal').subscribe((translatedText: string) => {
          this.NzMessageService.success(translatedText);
        })
        this.getmaintainData();
      })
  }



  //修改部门//
  handleCancel() {
    this.isdepartmentCharge = false
  }
  handleOk() {
    this.isdepartmentCharge = false
  }


  //WHQ
  DeptSearch() {
    this.isdepartmentCharge = true
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetPrListByPO.url}?po=` + this.Pono;
    this.WebApiService.doPost(url, this.Pono).subscribe(
      (res) => {

        this.departData = res.data.map((item) => {
          item.maintainTime = DateUtil.formatYMD(item.maintainTime);
          this.loading = false;
          return item;
        });
        this.updateEditCache()
        this.isdepartmentCharge = true;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }



  startEdit(id: string): void {

    this.editCache[id].edit = true;
  }

  cancelEdit(id: string): void {
    const index = this.departData.findIndex(item => item.id === id);
    this.editCache[id] = {
      data: { ...this.departData[index] },
      edit: false
    };
  }


  startEditDepts(id: string): void {

    this.editDepts[id].edit = true;
  }

  cancelEditDepts(id: string): void {
    const index = this.projAndDepts[0].findIndex(item => item.itemNo === id);
    this.editDepts[id] = {
      data: { ...this.projAndDepts[index] },
      edit: false
    };
  }


  //WHQ
  saveEdit(id: string): void {

    var changeDept = this.editCache[id].data.mDeptno
    var dis = this.editCache[id].data.dis
    const index = this.departData.findIndex(item => item.id === id);
    Object.assign(this.departData[index], this.editCache[id].data);
    this.editCache[id].edit = false;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.ChangeDept.url}`;
    const params = {
      data: {
        id: this.headId,
        changeDeptNo: changeDept,
        dis: dis,
        prid: this.editCache[id].data.id
      }
    };
    this.WebApiService.doPost(url, params,).subscribe(
      (res) => {
        //重新更新该modal
        const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetPrListByPO.url}?po=` + this.editCache[id].data.po;
        this.WebApiService.doPost(url, this.editCache[id].data.po).subscribe(
          (res) => {
            this.departData = res.data.map((item) => {
              item.maintainTime = DateUtil.formatYMD(item.maintainTime);
              this.loading = false;
              return item;
            });
            this.updateEditCache()
            this.isdepartmentCharge = true;
            this.loading = false;
          },
          (error) => {
            this.loading = false;
          }
        );


        // this.Changedept(this.editCache[id].data.po)
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  saveEditDepts(id: string): void {

    var changeDept = this.editDepts[id].data.chargeDeptNo
    var dis = this.editDepts[id].data.dis
    const index = this.editDeptsdata.findIndex(item => item.itemNo === id);
    Object.assign(this.editDeptsdata[index], this.editDepts[id].data);
    this.editDepts[id].edit = false;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.ChangeDept.url}`;
    const params = {
      data: {
        id: this.headId,
        changeDeptNo: changeDept,
        dis: dis,
        prid: this.editDepts[id].data.prchargeid
      }
    };

    this.WebApiService.doPost(url, params,).subscribe(
      (res) => {
        if (res.status == 200) {
          this.NzMessageService.success(res.msg);
        } else {
          this.NzMessageService.error(res.msg);
        }

        //重新更新该modal
        const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetPrListByPO.url}?po=` + this.Pono;
        this.WebApiService.doPost(url, this.Pono).subscribe(
          (res) => {
            //
            // this.editDeptsdata = res.data
            // console.log(this.editDeptsdata)
            // this.updateeditDeptsdata()


          },
          (error) => {

          }
        );


        // this.Changedept(this.editCache[id].data.po)
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  updateEditCache(): void {
    this.departData.forEach(item => {
      this.editCache[item.id] = {
        edit: false,
        data: { ...item }
      };
    });
  }

  updateeditDeptsdata(): void {
    this.editDeptsdata.forEach(item => {
      this.editDepts[item.itemNo] = {
        edit: false,
        data: { ...item }
      };
    });
  }

  ChangeselectDepart(value) {
    if (value.length > 2) {
      this.SelectDepartdata = []
      this.loading = true;
      const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.QueryAllowList.url}`;
      const req = {
        data: {
          companyErpNo: this.Company,
          search: value,
        }

      };
      this.WebApiService.doPost(url, req).subscribe(
        (res) => {
          this.SelectDepartdata = res.data
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    } else {
      this.SelectDepartdata = []
    }
  }


  Approveddisabled() {
    let Approveddisabled = true;
    var data = [];
    this.FirstsetOfCheckedId.forEach(O => {
      var dto = this.aliases.value.find(o => o.bind_id == O);
      if (dto != undefined) {
        data.push(dto);
      }
    })
    let terminateLoop = false
    if (data.length > 0) {
      data.forEach(item => {
        if (terminateLoop) {
          return;
        }
        if (item.Invoicestatus == "Ongoing") {
          Approveddisabled = false;
        } else {
          Approveddisabled = true;
          this.translate.get('Approveddisabled').subscribe((translatedText: string) => {
            this.NzMessageService.warning(translatedText);
          })
          terminateLoop = true
        }

      }
      );
    }
    return Approveddisabled
  }
  ////同意送出
  async Approved() {
    this.loading = true
    var InvoicesList = [];
    var PaymentsList = [];
    var data = [];
    this.FirstsetOfCheckedId.forEach(O => {
      var dto = this.aliases.value.find(o => o.bind_id == O);
      if (dto != undefined) {
        data.push(dto);
      }
    })
    if (data.length == 0) {
      this.loading = false
      this.translate.get('PleaseCheckData').subscribe((translatedText: string) => {
        return this.NzMessageService.warning(translatedText);
      })
    }
    if (await this.Approveddisabled()) {
      return this.loading = false
    }

    data.forEach((x, index) => {
      if (x.InvoiceDate != null) {
        x.InvoiceDate = this.CompareDate(x.InvoiceDate);
      }
      var alias = {
        bind_id: x.bind_id,
        poItemNo: x.Pono,
        rtNo: x.rtNo,
        rtItemNo: x.rtItemNo,
        itemNo: x.itemNo,
        invoiceNo: x.InvoiceNo,
        invoiceDate: x.InvoiceDate,
        expectDueDate: x.ExpectDueDate ? this.CompareDate(x.ExpectDueDate) : null,
        amount: x.NontaxInvoiceAmount,
        tax: x.Taxes,
        Id: x.id,
        remark: x.Remark,
        invoiceType: x.invoiceType
      };
      InvoicesList.push(alias);
    });

    this.RTDetail.value.filter(o => o.poItemNo != null).forEach(o => {
      const matchInvoice = data.find(invoice => invoice.InvoiceNo === o.DetailInvoiceNo);
      if (matchInvoice != undefined) {

        var alias = {
          detail_id: o.detail_id,
          itemNo: o.itemNo,
          invoiceNo: o.DetailInvoiceNo,
          poNo: o.Pono,
          poItemNo: o.poItemNo,
          invoiceDate: matchInvoice.InvoiceDate,
          amount: o.NotTaxAmount,
          tax: o.PATax,
          poQty: o.poQty,
          unpaidQty: o.unpaidQty,
          deliveryQty: o.deliveryQty,
          invoice_bindid: matchInvoice.bind_id,
          itemDesc: o.itemDesc,
        };
        PaymentsList.push(alias);
      }
    })

    if (InvoicesList.length === 0) {
      return true; // 如果数组为空，则默认发票类型相同
    }
    const firstInvoiceType = InvoicesList[0].invoiceType;
    for (let i = 1; i < InvoicesList.length; i++) {
      if (InvoicesList[i].invoiceType !== firstInvoiceType) {
        this.translate.get('TheInvoiceTypeIsInconsistent').subscribe((translatedText: string) => {
          return this.NzMessageService.warning(translatedText);
        })
      }
    }
    const params = {
      data: {
        companyNo: this.Company,
        siteNo: this.SiteNo,
        poNo: this.Pono,
        invoiceType: InvoicesList[0].invoiceType,
        applicationhead: {
          remark: InvoicesList.map(y => y.remark).join(';')
        },
        PaymentsList: PaymentsList,
        InvoicesList: InvoicesList
      }
    };



    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GeneratePayment.url}`;

    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (res.rc == 0) {
          this.NzMessageService.success("GPANO:" + res.paNo);
          setTimeout(() => {
            this.getmaintainData();
          }, 500); // 延迟500毫秒

          this.loading = false
        } else {
          this.NzMessageService.error(res.msg);
          this.loading = false
        }

      })

  }

  RejectCancel() {
    this.RemarkVisible = false
  }
  GetPaymentModel() {
    this.loading = true
    this.Inv = [];
    this.Pay = [];
    this.projAndDepts = [];

    //this.loading = true
    var InvoicesList = [];
    var PaymentsList = [];
    var data = [];
    this.FirstsetOfCheckedId.forEach(O => {
      var dto = this.aliases.value.find(o => o.bind_id == O);
      if (dto != undefined) {
        data.push(dto);
      }
    })
    if (data.length == 0) {
      this.loading = false
      this.translate.get('PleaseCheckData').subscribe((translatedText: string) => {
        return this.NzMessageService.warning(translatedText);
      })
    }
    if (this.Approveddisabled()) {
      return this.loading = false
    }

    data.forEach((x, index) => {
      if (x.InvoiceDate != null) {
        x.InvoiceDate = this.CompareDate(x.InvoiceDate);
      }
      var alias = {
        bind_id: x.bind_id,
        poItemNo: x.Pono,
        rtNo: x.rtNo,
        rtItemNo: x.rtItemNo,
        itemNo: x.itemNo,
        invoiceNo: x.InvoiceNo,
        invoiceDate: x.InvoiceDate,
        expectDueDate: x.ExpectDueDate ? this.CompareDate(x.ExpectDueDate) : null,
        amount: x.NontaxInvoiceAmount,
        tax: x.Taxes,
        Id: x.id,
        remark: x.Remark,
        invoiceType: x.invoiceType
      };
      InvoicesList.push(alias);
    });

    this.RTDetail.value.filter(o => o.poItemNo != null).forEach(o => {
      const matchInvoice = data.find(invoice => invoice.InvoiceNo === o.DetailInvoiceNo);
      if (matchInvoice != undefined) {
        var alias = {
          detail_id: o.detail_id,
          itemNo: o.itemNo,
          invoiceNo: o.DetailInvoiceNo,
          poNo: o.Pono,
          poItemNo: o.poItemNo,
          invoiceDate: matchInvoice.InvoiceDate,
          amount: o.NotTaxAmount,
          tax: o.PATax,
          poQty: o.poQty,
          unpaidQty: o.unpaidQty,
          deliveryQty: o.deliveryQty,
          invoice_bindid: matchInvoice.bind_id,
          itemDesc: o.itemDesc,
          rtno: null,
          rtln: null,
        };
        PaymentsList.push(alias);
      }
    })

    // Calculate the total deliveryQty for each invoiceNo
    this.deliveryQtyTotal = new Map<string, number>();
    PaymentsList.forEach(payment => {
      const invoiceNo = payment.invoiceNo;
      const deliveryQty = parseFloat(payment.deliveryQty);
      if (this.deliveryQtyTotal.has(invoiceNo)) {
        this.deliveryQtyTotal.set(invoiceNo, this.deliveryQtyTotal.get(invoiceNo) + deliveryQty);
      } else {
        this.deliveryQtyTotal.set(invoiceNo, payment.deliveryQty);
      }
    });

    if (InvoicesList.length === 0) {
      return true; // 如果数组为空，则默认发票类型相同
    }
    const firstInvoiceType = InvoicesList[0].invoiceType;
    for (let i = 1; i < InvoicesList.length; i++) {
      if (InvoicesList[i].invoiceType !== firstInvoiceType) {
        this.translate.get('TheInvoiceTypeIsInconsistent').subscribe((translatedText: string) => {
          return this.NzMessageService.warning(translatedText);
        })
      }
    }



    const params = {
      data: {
        companyNo: this.Company,
        siteNo: this.SiteNo,
        poNo: this.Pono,
        invoiceType: InvoicesList[0].invoiceType,
        applicationhead: {
          remark: InvoicesList.map(y => y.remark).join(';')
        },
        PaymentsList: PaymentsList,
        InvoicesList: InvoicesList
      }
    };
    this.PaInvoicesList = InvoicesList;
    this.PaPaymentsList = PaymentsList;

    const Temporaryurl = `${this.Environment.authConfig.wmsmUrl}${URLConst.TemporaryStorage.url}`;
    this.WebApiService.doPost(Temporaryurl, params).subscribe(
      (res) => {
        if (res.status == 200) {
          const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetPaymentInfo.url}`;
          this.WebApiService.doPost(url, params).subscribe(
            (res) => {
              if (res.rc == 1) {
                this.loading = false
                this.GetPaymentInfo = false;
                this.NzMessageService.error(res.msg);
              } else {
                this.loading = false
                this.GetPaymentInfo = true;
                console.log(res.data, '111');
                this.Inv.push(res.data.invoices);
                this.Pay.push(res.data.details);
                this.projAndDepts.push(res.data.details[0].projAndDepts);
                this.editDeptsdata = this.projAndDepts[0];
                this.updateeditDeptsdata()
                this.Pay[0].forEach((item) => {
                  item.rtNoOptions = [];
                  item.rtItemNoOptions = [];
                  item.rtNoOptions.push(item.rtNo);
                  item.rtItemNoOptions.push(item.rtItemNo);
                });
                console.log(this.editDeptsdata, "this.editDeptsdata");
              }

            });
        }
      }
    )
  }



  RtNoclick(value: any, index: number): void {
    this.loading = true
    const POdata = {
      data: {
        Pono: this.Pono,
        PoLn: value.poItemNo,
      }
    }
    let url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetRt.url}`;
    this.WebApiService.doPost(url, POdata).subscribe(
      (res) => {
        this.loading = false
        this.RTNOList = res.data
        this.Pay[0][index].rtNoOptions = [];
        this.Pay[0][index].rtItemNoOptions = [];
        res.data.forEach((item) => {
          this.Pay[0][index].rtNoOptions.push(item.rtno);
          this.Pay[0][index].rtItemNoOptions.push(item.rtln);
        });
      }
    )
  }

  //修改RTNO
  RtNoChange(item: any, value: any, index: number): void {
    item.rtNo = value;
    const selectedRT = this.RTNOList.find(rt => rt.rtno === value);
    this.Pay[0][index].rtItemNoOptions = [];
    if (selectedRT) {
      item.rtItemNo = selectedRT.rtln;
      item.qty = selectedRT.rtQty;
      this.Pay[0][index].rtItemNoOptions.push(selectedRT.rtln);
      this.qtyChange(item, selectedRT.rtQty, index)
    }
  }
  //修改 qty
  qtyChange(item: any, value: any, index: number) {
    item.amount = parseFloat(((item.price * value) - (((item.price * value) / 1.05) * 0.05)).toFixed(2));
    item.tax = parseFloat((((item.price * value) / 1.05) * 0.05).toFixed(2));
  }

  //选择RT后确定
  PaymentInfoOk() {
    // Update PaInvoicesList with expectDueDate from Inv[0]
    if (this.Inv.length > 0 && this.Inv[0].length > 0) {
      this.Inv[0].forEach(invItem => {
        const target = this.PaInvoicesList.find(p => p.invoiceNo === invItem.invoiceNo);
        if (target) {
          target.expectDueDate = invItem.expectDueDate ? this.CompareDate(invItem.expectDueDate) : null;
        }
      });
    }

    this.isLoadingPaymentInfo = true
    var PaymentsList = [];

    var EpaOrGpa = false;
    this.Pay[0].forEach(o => {

      EpaOrGpa = o.rtNo != null && o.rtItemNo != null;
      var alias = {
        detail_id: o.id,
        itemNo: o.itemNo,
        invoiceNo: o.invoiceNo,
        poNo: o.poNo,
        poItemNo: o.poItemNo,
        invoiceDate: o.InvoiceDate,
        amount: o.amount,
        tax: o.tax,
        poQty: o.poQty,
        unpaidQty: o.unpaidQty,
        deliveryQty: o.qty,
        invoice_bindid: o.invoice_bindid,
        itemDesc: o.itemDesc,
        rtno: o.rtNo,
        rtln: o.rtItemNo,
      };
      PaymentsList.push(alias);
    })

    // Calculate the total delivery quantity for each invoice number
    const invoiceDeliveryQtyMap = new Map<string, number>();

    PaymentsList.forEach((payment) => {
      const invoiceNo = payment.invoiceNo;
      const deliveryQty = parseFloat(payment.deliveryQty);
      if (invoiceDeliveryQtyMap.has(invoiceNo)) {
        const currentTotal = invoiceDeliveryQtyMap.get(invoiceNo);
        invoiceDeliveryQtyMap.set(invoiceNo, currentTotal + deliveryQty);
      } else {
        invoiceDeliveryQtyMap.set(invoiceNo, deliveryQty);
      }
    });
    this.deliveryQtyTotal
    let isMatched = true;
    if (EpaOrGpa) {
      invoiceDeliveryQtyMap.forEach((value, key) => {
        if (this.deliveryQtyTotal.get(key) !== value) {
          isMatched = false;
        }
      });
    }

    const mismatchedKeys: string[] = [];
    const deliveryQtyTotalValues: string[] = [];
    if (!isMatched) {
      invoiceDeliveryQtyMap.forEach((value, key) => {
        if (this.deliveryQtyTotal.get(key) !== value) {
          mismatchedKeys.push(key);
          deliveryQtyTotalValues.push(String(this.deliveryQtyTotal.get(key))); // Convert number to string
        }
      });
      const mismatchedKeysString = mismatchedKeys.map(key => `'${key}': ${invoiceDeliveryQtyMap.get(key)}`).join(', ');
      this.isLoadingPaymentInfo = false;
      var msg1;
      var msg2;
      this.translate.get('InvoiceNo').subscribe((translatedText: string) => {
        msg1 = translatedText;
      });
      this.translate.get('QTYMsg').subscribe((translatedText: string) => {
        msg2 = translatedText;
      });
      const errorMessage = `${msg1}: ${mismatchedKeys} ${msg2}: ${deliveryQtyTotalValues}`;
      return this.NzMessageService.error(errorMessage);
    }

    const params = {
      data: {
        companyNo: this.Company,
        siteNo: this.SiteNo,
        poNo: this.Pono,
        invoiceType: this.PaInvoicesList[0].invoiceType,
        applicationhead: {
          remark: this.PaInvoicesList.map(y => y.remark).join(';')
        },
        PaymentsList: PaymentsList,
        InvoicesList: this.PaInvoicesList
      }
    };

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.ConfirmPayment.url}`;
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (res.rc == 1) {
          this.NzMessageService.error(res.msg)
          this.isLoadingPaymentInfo = false
        } else {
          this.NzMessageService.success(res.paNo)
          this.GetPaymentInfo = false;
          this.isLoadingPaymentInfo = false
          this.getmaintainData();
        }


      })
  }



  disablePaymentInfo() {
    this.GetPaymentInfo = false;
  }



  RejectOk() {
    this.RemarkVisible = false
    var data1 = [];
    this.FirstsetOfCheckedId.forEach(O => {
      var dto = this.aliases.value.find(o => o.bind_id == O);
      data1.push(dto);
    })

    var data = []
    var id = {
      invoiceId: data1[0].id,
      headId: this.headId,
    }

    data.push(id)
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.Reject.url}`;
    const req = {
      data: {
        rejectMsg: this.RejectinputValue,
        data: data,

      }

    };
    this.WebApiService.doPost(url, req).subscribe(
      (res) => {
        this.translate.get('RejectSuccess').subscribe((translatedText: string) => {
          this.NzMessageService.success(translatedText);
        })
        this.getmaintainData()
      },
      (error) => {
      }
    );
  }
  ////拒绝
  Reject() {
    var data = [];
    this.FirstsetOfCheckedId.forEach(O => {
      var dto = this.aliases.value.find(o => o.bind_id == O);
      if (dto != undefined) {
        data.push(dto);
      }
    })
    if (data.length == 0) {
      this.loading = false
      this.translate.get('PleaseCheckData').subscribe((translatedText: string) => {
        return this.NzMessageService.warning(translatedText);
      })
    } else if (data.length == 1) {
      data.forEach(item => {
        if (item.Invoicestatus == "Ongoing") {
          this.RemarkVisible = true;
        } else {
          this.RemarkVisible = false;
          this.translate.get('只能拒絕Ongoing狀態下的發票').subscribe((translatedText: string) => {
            return this.NzMessageService.warning(translatedText);
          })
        }
      });

    } else if (data.length > 1) {
      this.translate.get('只能拒絕一條數據').subscribe((translatedText: string) => {
        return this.NzMessageService.warning(translatedText);
      })
      this.RemarkVisible = false;
    }
  }


  InvoiceSwitch(key: string, value: any) {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpdateInvoiceType.url}`;
    const req = {
      data: {
        headId: this.headId,
        invoiceId: value.id,
        detailId: value.id,
        key: key,
      }

    };
    this.WebApiService.doPost(url, req).subscribe(
      (res) => {
      },
      (error) => {
      }
    );
  }

}


